import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { USERS_COLLECTION, QUIZ_RESULTS_SUBCOL } from "../UserProfile/StudentProfile/StudentDashboard";

export const useQuizResults = (uid) => {
  const [performance, setPerformance] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) return;
    const unsub = onSnapshot(
      collection(db, USERS_COLLECTION, uid, QUIZ_RESULTS_SUBCOL),
      (snap) => {
        const obj = {};
        snap.docs.forEach((d) => (obj[d.id] = d.data()));
        setPerformance(obj);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [uid]);

  return { performance, loading };
};
